
const ExperienceSection = () => {
  const certifications = [
    {
      title: "Certified International Trade Professional",
      organization: "International Trade Council",
      icon: "ri-award-line"
    },
    {
      title: "Shopify Plus Partner",
      organization: "Shopify",
      icon: "ri-store-line"
    },
    {
      title: "Google Analytics Certified",
      organization: "Google",
      icon: "ri-line-chart-line"
    },
    {
      title: "Amazon Advertising Certified",
      organization: "Amazon",
      icon: "ri-advertisement-line"
    }
  ];

  const experience = [
    {
      metric: "500+",
      label: "Businesses Helped",
      description: "From startups to established brands"
    },
    {
      metric: "$50M+",
      label: "Revenue Generated",
      description: "Through international expansion"
    },
    {
      metric: "25+",
      label: "Countries Entered",
      description: "Across all major markets"
    },
    {
      metric: "98%",
      label: "Client Satisfaction",
      description: "Based on post-project surveys"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Experience Metrics */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Proven Track Record
          </h2>
          <p className="text-xl text-gray-600 mb-12">
            Numbers that speak to our commitment and expertise
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {experience.map((item, index) => (
              <div key={index} className="text-center p-6 bg-white rounded-lg shadow-sm">
                <div className="text-4xl font-bold text-teal-600 mb-2">{item.metric}</div>
                <div className="text-lg font-semibold text-gray-900 mb-2">{item.label}</div>
                <div className="text-sm text-gray-600">{item.description}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            Certifications & Partnerships
          </h3>
          <p className="text-lg text-gray-600 mb-12">
            We maintain the highest industry standards and partnerships
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mx-auto mb-4">
                  <i className={`${cert.icon} text-2xl text-teal-600`}></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">{cert.title}</h4>
                <p className="text-sm text-gray-600">{cert.organization}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
